import {required, numeric, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import {USER_GROUPS} from "@/store/auth/auth";
import {ModelObject} from "@/pages/Common/modelObject";

export class Question extends ModelObject {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.id = null;
        this.text = null;
        this.answer = null;
        this.group = null;
        this.listOrder = 0;
        this.publish = false;

        this.attachments = [];
        this.groupObject = {};

        this.applyInitObjectParams(initObjectParams)
    }

    static get modelName() {
        return 'Organization'
    }


    static get validations() {
        return {
            text: {required},
            answer: {required},
            group: {required},
            publish: {},
            listOrder: {},
            attachments: {},
        }
    }

    static get validationFieldLabels() {
        return {
            text: 'Вопрос',
            answer: 'Ответ',
            group: 'Группа',
            listOrder: 'Порядок',
            publish: 'Публиковать на сайте'
        }
    }

    static get mapping() {
        return {
            listOrder: 'list_order'
        }
    }

    static get label() {
        return 'Вопрос-ответ'
    }

    label() {
        return 'Вопрос-ответ'
    }

    static get newLabel() {
        return 'Вопрос-ответ'
    }

    objectLabel() {
        return this.text
    }

    applyData(data) {
        super.applyData(data)
    }

}